require('./accountLastMovementsContentFilters.scss');

const React = require('react');
const PropTypes = require('prop-types');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { CONCEPTS } = require('constants/movementsTypes');
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { countActiveFilters } = require('utilities/filtersHelper');
// @ constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');

class AccountLastMovementsContentFilters extends React.Component {

    constructor(props) {
        super(props);

        this.buildAmountFilterLabel = this.buildAmountFilterLabel.bind(this);
        this.buildDateFilterLabel = this.buildDateFilterLabel.bind(this);
    }

    getConcept(key) {
        return CONCEPTS.filter(
            conceptObj => conceptObj.key === key
        )[0];
    }

    buildTextFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const labeltext = immFilter
            .get('description')
        
        return (
            <LabelFilterRange closeCallback={() => resetFilter('description')} key="filter-description" from={labeltext.get('selected')} />
        );
    }

    buildAmountFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immFilterAmount = immFilter.get('amount');
        const plainAmountFromObject = getPlainAmountObject(immFilterAmount.get('from'));
        const plainAmountToObject = getPlainAmountObject(immFilterAmount.get('to'));
        const language = getLanguage();
        let fromElem = null, toElem = null;

        if (immFilterAmount.get('from').get('amount') !== null) {
            fromElem = (
                <span>
                    <FormattedText value="filters-min" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountFromObject}
                        className="account-last-movements-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountFromObject, true)} />
                </span>
            );
        }

        if (immFilterAmount.get('to').get('amount') !== null) {
            toElem = (
                <span>
                    <FormattedText value="filters-max" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountToObject}
                        className="account-last-movements-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountToObject, true)} />
                </span>
            );
        }

        return (
            <LabelFilterRange
                key="filter-amount"
                from={fromElem}
                to={toElem}
                closeCallback={() => resetFilter('amount')}
            />
        );
    }

    buildConceptFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immConceptFilter = immFilter.get('concept');
        const concept = formatText(this.getConcept(immConceptFilter.get('concept')).label);
        const conceptLabel = formatText('filters-concept', [concept]);
        return (
            <LabelFilterRange
                key="filter-concept"
                from={conceptLabel}
                closeCallback={() => resetFilter('concept')}
            />
        );
    }

    buildDateFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immFilterDate = immFilter.get('date');
        const language = getLanguage();
        const labelFromDate = immFilterDate.get('from').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        const labelToDate = immFilterDate.get('to').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => resetFilter('date')}
            />
        );
    }

    buildMovementTypeFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immMovementTypeFilter = immFilter.get('movementType');
        const movementTypeName = formatText('movementTypes-typeName' + immMovementTypeFilter.get('movementType'));
        const movementTypeLabel = formatText('filters-movementType', [movementTypeName]);
        return (
            <LabelFilterRange
                key="filter-movementType"
                from={movementTypeLabel}
                closeCallback={() => resetFilter('movementType')}
            />
        );
    }

    createButtonClearAllFilters() {
        const { immFilter, clearFilters } = this.props;
        let response;

        if (countActiveFilters(immFilter) > 1) {
            response = <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={clearFilters} />;
        }

        return response;
    }

    render() {
        const { immFilter } = this.props;
        const immFilterAmount = immFilter.get('amount');
        const immFilterDate = immFilter.get('date');
        const immMovementTypeFilter = immFilter.get('movementType');
        const immConceptFilter = immFilter.get('concept');
        const immTextFilter = immFilter.get('description');
        const filterAmountLabel = immFilterAmount.get('isActive') ? this.buildAmountFilterLabel() : '';
        const filterDateLabel = immFilterDate.get('isActive') ? this.buildDateFilterLabel() : '';
        const movementTypeFilterLabel = immMovementTypeFilter.get('isActive') ? this.buildMovementTypeFilterLabel() : '';
        const textFilterActiveContent = immTextFilter.get('isActive')  ? this.buildTextFilterLabel() : '';
        const conceptFilterLabel = immConceptFilter.get('isActive') ? this.buildConceptFilterLabel() : '';
        const clearAllFiltersButton = this.createButtonClearAllFilters();
        // we can continue doing this for extra filters

        return (
            <div className="account-last-movements-content-filters">
                {textFilterActiveContent}
                {conceptFilterLabel}
                {movementTypeFilterLabel}
                {filterAmountLabel}
                {filterDateLabel}
                {clearAllFiltersButton}
            </div>
        );
    }
}

AccountLastMovementsContentFilters.propTypes = {
    immFilter: PropTypes.object.isRequired,
    immTransactions: PropTypes.object,
    clearFilters: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    immTextFilter: PropTypes.object.isRequired,

}

module.exports = AccountLastMovementsContentFilters;
